import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabaseClient'
import '../styles/AuthPage.css'

export default function ResetPasswordPage() {
  const [password, setPassword]         = useState('')
  const [confirm, setConfirm]           = useState('')
  const [loading, setLoading]           = useState(false)
  const [error, setError]               = useState(null)
  const [success, setSuccess]           = useState(false)
  const [validSession, setValidSession] = useState(false)
  const [linkError, setLinkError]       = useState(null)

  useEffect(() => {
    // Check for error in URL hash (expired/invalid link)
    const hash = window.location.hash
    const params = new URLSearchParams(hash.replace('#', '?'))
    const urlError = params.get('error_description')
    if (urlError) {
      setLinkError(urlError.replace(/\+/g, ' '))
      return
    }

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        setValidSession(true)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  const handleReset = async () => {
    if (!password)              return setError('Enter a new password.')
    if (password.length < 6)   return setError('Password must be at least 6 characters.')
    if (password !== confirm)   return setError('Passwords do not match.')

    setLoading(true); setError(null)
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)

    if (error) return setError(error.message)
    setSuccess(true)
    setTimeout(() => window.location.href = '/', 2000)
  }

  if (linkError) {
    return (
      <div className="page-bg auth-root">
        <div className="auth-overlay" />
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo">AZERODLE</h1>
            <p className="auth-tagline2">Password Reset</p>
          </div>
          <div className="auth-body">
            <div className="auth-error">⚠ {linkError}</div>
            <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.8rem' }}>
              <a href="/" style={{ color: 'var(--gold-mid)', textDecoration: 'underline' }}>
                ← Back to home
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (!validSession) {
    return (
      <div className="page-bg auth-root">
        <div className="auth-overlay" />
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo">AZERODLE</h1>
            <p className="auth-tagline2">Password Reset</p>
          </div>
          <div className="auth-body">
            <p style={{ textAlign: 'center', color: 'var(--text-muted, #aaa)', padding: '1rem 0' }}>
              Verifying reset link...
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (success) {
    return (
      <div className="page-bg auth-root">
        <div className="auth-overlay" />
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo">AZERODLE</h1>
          </div>
          <div className="auth-body">
            <div className="auth-success">✔ Password changed! Redirecting...</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="page-bg auth-root">
      <div className="auth-overlay" />
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-logo">AZERODLE</h1>
          <p className="auth-tagline1">World of Warcraft</p>
          <p className="auth-tagline2">Set New Password</p>
        </div>
        <div className="auth-body">
          <div className="auth-field">
            <label className="auth-label">New Password</label>
            <input
              className="input"
              type="password"
              placeholder="min. 6 characters"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="auth-field">
            <label className="auth-label">Confirm Password</label>
            <input
              className="input"
              type="password"
              placeholder="repeat password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleReset()}
            />
          </div>
          <button
            className="btn-gold"
            style={{ width: '100%', marginTop: '0.5rem' }}
            onClick={handleReset}
            disabled={loading}
          >
            {loading && <span className="loading-spinner" />}
            {loading ? 'Saving...' : 'Set New Password'}
          </button>
          {error && <div className="auth-error">⚠ {error}</div>}
        </div>
        <div className="auth-footer">For the Horde · For the Alliance</div>
      </div>
    </div>
  )
}